import React from 'react';
import PropTypes from 'prop-types';

const BleedZone = ({ sku, pageWidth, pageHeight, value }) => {
  const [bleedLeft, bleedTop, bleedRight, bleedBottom] = value;

  let background = '#FF00003A';
  let title = 'Items in the shaded area may be cut off';
  let text;
  if (sku.includes('gallery-wrapped')) {
    background = '#FFFFFF8A';
    title = 'The shaded border indicates the wrapped area.';
    text = "WRAP AREA"
  }

  return (
    <>
      {[
        {
          id: 'bleed-left',
          x: 0,
          y: bleedTop / pageHeight,
          width: bleedLeft / pageWidth,
          height: (pageHeight - bleedTop - bleedBottom) / pageHeight,
          rotateText: -90
        },
        { id: 'bleed-top', x: 0, y: 0, width: 1, height: bleedTop / pageHeight, rotateText: 0 },
        {
          id: 'bleed-right',
          x: (pageWidth - bleedRight) / pageWidth,
          y: bleedTop / pageHeight,
          width: bleedRight / pageWidth,
          height: (pageHeight - bleedTop - bleedBottom) / pageHeight,
          rotateText: 90
        },
        {
          id: 'bleed-bottom',
          x: 0,
          y: (pageHeight - bleedBottom) / pageHeight,
          width: 1,
          height: bleedBottom / pageHeight,
          rotateText: 0
        },
      ].map(item => (
        <div
          key={item.id}
          className="editor-placeholder d-flex justify-content-center align-items-center overflow-hidden"
          style={{
            left: `${item.x * 100}%`,
            top: `${item.y * 100}%`,
            width: `${item.width * 100}%`,
            height: `${item.height * 100}%`,
            background,
          }}
          title={title}
        >
          {text && <span className="text-primary text-center font-weight-bold position-absolute" style={{ transform: `rotate(${item.rotateText}deg)`, fontSize: `3vw`, width: "50vw" }}>{text}</span>}
        </div>
      ))}
    </>
  );
};

BleedZone.propTypes = {
  sku: PropTypes.string,
  pageWidth: PropTypes.number,
  pageHeight: PropTypes.number,
  value: PropTypes.array,
};

export default BleedZone;
